import { Breakpoints, styled, ThemeDefinition } from '@vw-marketing/us-components';

export const StyledVehicleImageContainer = styled.div`
  ${({ ciGuidelinesRollout, theme }: { ciGuidelinesRollout: boolean, theme: ThemeDefinition }) => {
    return `
      align-items: center;
      display: flex;
      flex: 1;
      ${ciGuidelinesRollout && `background: ${theme.colors.background.highlight}`};
      justify-content: center;
      margin-left: -8.33vw;
      margin-right: -8.33vw;
      max-height: 200px;
      min-height: 185px;
      padding: ${theme.size.static400} ${theme.size.static500};

      img {
        min-width: 230px;
      }
      
      @media (min-width: ${Breakpoints.b560}px) {
        background: transparent;
        flex: 1 1 0;
        margin-left: 0px;
        margin-right: 0px;
        max-height: 266px;
        min-height: 266px;
        min-width: 0;
        padding: ${theme.size.static200} ${theme.size.static100};

        img {
          min-width: 0;
          max-width: 100%;
          width: 100%;
          object-fit: contain;
        }

        @media (min-width: ${Breakpoints.b560}px) and (max-width: ${Breakpoints.b960}px) {
          img {
            transform: scale(1.3);
            min-width: 220px;
            max-width: 280px;
          }
        }
      }

      @media (min-width: ${Breakpoints.b960}px) {
        height: auto;
        min-height: auto;
        max-height: auto;
      }

      @media (min-width: ${Breakpoints.b1920}px) {
        flex: none;

        img {
          max-width: 500px;
        }
      }
    `;
  }}
`;